var convert = require('./convert'),
    func = convert('merge', require('../merge'));

func.placeholder = require('./placeholder');
module.exports = func;



//////////////////
// WEBPACK FOOTER
// ./~/vuelayers/~/lodash/fp/merge.js
// module id = 1348
// module chunks = 1